import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mouse_wheel.svg'


const _withScopeId = n => (_pushScopeId("data-v-79e644a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onWheel"]
const _hoisted_2 = { class: "normal_viewer video_wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onWheel"]
const _hoisted_5 = ["width", "height"]
const _hoisted_6 = {
  key: 0,
  class: "coach_mark"
}
const _hoisted_7 = { class: "coach_mark_inner" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = ["innerHTML"]

import ResizeBox from '@/components/atoms/ResizeBox'
import FISHEYE from '@/js/const/fisheye'
import { useBrowserName } from '@/js/utils/util'
import { useStore } from 'vuex'
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  shallowRef,
  watch,
  withDefaults,
} from 'vue'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DisplaySizeType = {
  width?: number
  height?: number
}

type CameraDetailType = {
  image_rs_width?: number
  image_rs_height?: number
  image_fps?: number
}

type RegionType = {
  centerX: number
  centerY: number
  radius: number
}

type EulerType = {
  pitch: number
  yaw: number
}

type PropsType = {
  useVideo?: boolean
  displaySize?: DisplaySizeType
  liveImg?: HTMLElement
  liveImageSrc?: string
  videoPath?: string
  cameraDetail?: CameraDetailType
  isPaused?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FisheyeViewer',
  props: {
    useVideo: { type: Boolean, default: false },
    displaySize: null,
    liveImg: null,
    liveImageSrc: null,
    videoPath: null,
    cameraDetail: null,
    isPaused: { type: Boolean }
  },
  emits: ["loadeddata", "ended", "error", "setFisheyeViewerElement", "setVideoElement"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'loadeddata', video: HTMLVideoElement | null): void
  (e: 'ended'): void
  (e: 'error'): void
  (e: 'setFisheyeViewerElement', element: HTMLElement | null): void
  (e: 'setVideoElement', element: HTMLVideoElement | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { useVideo: boolean, displaySize?: DisplaySizeType, liveImg?: HTMLElement, liveImageSrc?: string, videoPath?: string, cameraDetail?: CameraDetailType, isPaused?: boolean };

let THREE: any = null
const archiveImg = new Image()
const MESH_NUM = 32





const store = useStore()

const fisheyeViewerWrap = ref<HTMLElement | null>(null)
const fisheyeViewer = ref<HTMLElement | null>(null)
const video = ref<HTMLVideoElement | null>(null)
const normalViewer = ref<HTMLCanvasElement | null>(null)

const source = shallowRef<HTMLElement | HTMLVideoElement | HTMLImageElement | null>(null)
const exponent = ref(10)
const canvas = shallowRef<HTMLCanvasElement | null>(null)
// Three.js オブジェクトは Vue の deep reactive にすると modelViewMatrix 等で壊れるため shallowRef にする
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const camera = shallowRef<any>(null)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderer = shallowRef<any>(null)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const scene = shallowRef<any>(null)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const local = shallowRef<any>(null)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const collisionSphere = shallowRef<any>(null)
const fisheyeCtx = shallowRef<CanvasRenderingContext2D | null>(null)
const normalViewerCtx = shallowRef<CanvasRenderingContext2D | null>(null)
const region = ref<RegionType>({ centerX: 300, centerY: 300, radius: 300 })
const pos = ref<number[]>([0, 0, 0, 0, 0, 0, 0, 0])
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const meshes = shallowRef<any[]>([])
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const textures = shallowRef<any[]>([])
const prevEuler = ref<EulerType>({ pitch: 0, yaw: 0 })
const dragging = ref(false)
const renderTimer = ref<ReturnType<typeof setTimeout> | null>(null)
const isShowCoachMark = ref(false)
const zoom = ref(1)

const displayedCoachMark = computed<boolean>(() => store.getters['fisheye/displayedCoachMark'])

const setDisplayState = (displayState: string) => {
  store.commit('fisheye/setDisplayState', displayState)
}
const resetState = () => {
  store.commit('fisheye/resetState')
}
const setDisplayedCoachMark = (displayed: boolean) => {
  store.commit('fisheye/setDisplayedCoachMark', displayed)
}

const cameraResolutionStr = computed(
  () => `${props.cameraDetail?.image_rs_width}_${props.cameraDetail?.image_rs_height}`
)

const calibration = computed(
  () => FISHEYE.CALIBRATION[cameraResolutionStr.value] || FISHEYE.CALIBRATION['1280_720']
)

const canvasSize = computed(() => {
  if (!renderer.value || !THREE) {
    return { width: 0, height: 0 }
  }
  return renderer.value.getSize(new THREE.Vector2())
})

const cameraPitchMax = computed(
  () => calibration.value.pitchMax - calibration.value.pitchRangeForZoom * zoom.value
)

const cameraPitchMin = computed(
  () => calibration.value.pitchMin + calibration.value.pitchRangeForZoom * zoom.value
)

const videoStyle = computed(() => ({
  height: `${props.displaySize?.height}px`,
  width: `${props.displaySize?.width}px`,
}))

const isLowerMinScale = computed(() => {
  if (!camera.value) return
  return calibration.value.minZoom >= zoom.value
})

const cameraSize = computed(() => {
  const size = cameraResolutionStr.value.split('_')
  return {
    width: Number(size[0]),
    height: Number(size[1]),
  }
})

const updateInterval = computed(() => {
  const ms = 1000 / (props.cameraDetail?.image_fps as number)
  return ms < 200 ? ms : 200
})

const canvasStyle = computed(() => ({
  width: props.displaySize?.width + 'px',
  height: props.displaySize?.height + 'px',
}))

/**
 * ライブ標準ビュアーの初期化
 */
const initNormalLiveViewer = () => {
  if (!normalViewer.value) {
    return
  }
  normalViewerCtx.value = normalViewer.value.getContext('2d')
}

/**
 * 360度ビュアーの初期化(webgl関連)
 */
const initFisheyeViewer = () => {
  camera.value = new THREE.PerspectiveCamera(30, 4 / 3, 1, 1000)
  renderer.value = new THREE.WebGLRenderer({
    preserveDrawingBuffer: true,
  })
  scene.value = new THREE.Scene()
  canvas.value = renderer.value.domElement
  fisheyeCtx.value = document.createElement('canvas').getContext('2d')
  local.value = new THREE.Object3D()
  const sphereGeom = new THREE.SphereGeometry(100, 32, 16)
  const blueMaterial = new THREE.MeshBasicMaterial({
    color: 0x0000ff,
    side: THREE.BackSide,
    transparent: true,
    opacity: 0,
  })
  collisionSphere.value = new THREE.Mesh(sphereGeom, blueMaterial)

  scene.value.add(local.value)
  scene.value.add(collisionSphere.value)
  scene.value.add(camera.value)

  canvas.value.setAttribute('id', 'fisheye-viewer')
}

/**
 * UI操作用のイベントを設定
 */
const setEvent = () => {
  canvas.value.addEventListener('mousemove', (e: MouseEvent) => {
    if (dragging.value) {
      drag('move', e.offsetX, e.offsetY)
    }
  })
  canvas.value.addEventListener('mousedown', (e: MouseEvent) => {
    dragging.value = true
    drag('start', e.offsetX, e.offsetY)
  })
  canvas.value.addEventListener('mouseup', () => {
    dragging.value = false
  })
  canvas.value.addEventListener('mouseleave', () => {
    dragging.value = false
  })
}

/**
 * 360度ビュアーの初期化(webgl関連)
 */
const setSrc = (src: HTMLElement | HTMLVideoElement | HTMLImageElement | null | undefined) => {
  if (src == null || src === source.value) {
    return
  }
  source.value = src
  load()
}

/**
 * 魚眼の円の位置を調整する
 */
const setFisheyeRegion = (prop: RegionType) => {
  region.value = prop
  updateFisheyeRegion()
}

/**
 * 表示サイズを設定
 */
const setCanvasSize = (size: DisplaySizeType) => {
  if (!renderer.value || size.width == null || size.height == null) {
    return
  }
  renderer.value.setSize(size.width, size.height)
  if (camera.value?.isPerspectiveCamera) {
    camera.value.aspect = size.width / size.height
    camera.value.updateProjectionMatrix()
  }
}

/**
 * 拡大率を設定
 */
const setZoom = (scale: number) => {
  if (!camera.value || !local.value) {
    return
  }
  zoom.value = scale
  camera.value.zoom = scale
  camera.value.updateProjectionMatrix()
  if (cameraPitchMin.value < -local.value.rotation.x) {
    setPitch(cameraPitchMin.value)
  } else if (cameraPitchMax.value > -local.value.rotation.x) {
    setPitch(cameraPitchMax.value)
  }
}

/**
 * 映像の表示位置の変更(３次元ベクトルの回転を設定)
 */
const setCameraPose = ({ pitch, yaw: yawVal }: EulerType) => {
  setPitch(pitch)
  setYaw(yawVal)
}

/**
 * 映像のY軸歩行の回転率を設定
 */
const setPitch = (pitch: number) => {
  if (!local.value) {
    return
  }
  local.value.rotation.x = -pitch
}

/**
 * 映像のZ軸歩行の回転率を設定
 */
const setYaw = (yawVal: number) => {
  if (meshes.value.length === 0) {
    return
  }

  meshes.value[0].rotation.z = yawVal
}

/**
 * 魚眼クリッピング領域の計算
 */
const updateFisheyeRegion = () => {
  if (!fisheyeCtx.value) {
    return
  }
  const pow = Math.pow(2, exponent.value)
  const { radius, centerX, centerY } = region.value
  const clippedWidth = radius * 2
  const clippedHeight = radius * 2
  const left = centerX - radius
  const top = centerY - radius

  let [sx, sy] = [left, top]
  let [sw, sh] = [clippedWidth, clippedHeight]
  let [dx, dy] = [0, 0]
  let [dw, dh] = [pow, pow]
  if (left < 0) {
    sx = 0
    sw = clippedWidth - left
    dx = (-left * pow) / clippedWidth
    dw = (sw * pow) / clippedWidth
  }
  if (top < 0) {
    sy = 0
    sh = clippedHeight - top
    dy = (-top * pow) / clippedHeight
    dh = (sh * pow) / clippedHeight
  }
  pos.value = [sx, sy, sw, sh, dx, dy, dw, dh]
  fisheyeCtx.value.canvas.width = pow
  fisheyeCtx.value.canvas.height = pow
}

/**
 * テクスチャ用のVideo、画像のロード
 */
const load = () => {
  unload()

  const texture = new THREE.Texture(fisheyeCtx.value.canvas)
  const mesh = createFisheyeMesh(texture)

  local.value.add(mesh)
  meshes.value.push(mesh)
  textures.value.push(texture)
}

/**
 * 以前のリソースを消す
 */
const unload = () => {
  meshes.value.forEach((mesh) => {
    local.value.remove(mesh)
    mesh.geometry.dispose()
    mesh.material.dispose()
  })
  textures.value.forEach((tex) => {
    tex.dispose()
  })
  meshes.value = []
  textures.value = []
}

/**
 * cam.src の size にテクスチャを合わせる
 */
const resize = () => {
  if (renderer.value && props.displaySize) {
    setCanvasSize(props.displaySize)
  }

  if (source.value && fisheyeCtx.value) {
    updateFisheyeRegion()
  }
}

/**
 * 正方形テクスチャを半球に投影したマテリアルとそのメッシュを得る
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createFisheyeMesh = (texture: any) => {
  const sphere = new THREE.SphereGeometry(1000, MESH_NUM, MESH_NUM, Math.PI, Math.PI)

  sphere.computeBoundingSphere()
  sphere.boundingSphere.center = new THREE.Vector3(0, 1, 0)
  sphere.boundingSphere.radius = 1000

  updateUv(sphere)

  const mat = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    map: texture,
    side: THREE.BackSide,
  })
  const mesh = new THREE.Mesh(sphere, mat)
  mesh.rotation.x = (Math.PI * 1) / 2
  return mesh
}

/**
 * UV座標を更新
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const updateUv = (sphere: any) => {
  const radius = sphere.boundingSphere.radius
  const position = sphere.attributes.position
  const uvAttribute = sphere.attributes.uv

  for (let i = 0; i < position.count; i++) {
    const x = position.getX(i)
    const y = position.getY(i)
    const u = (x + radius) / (2 * radius)
    const v = (y + radius) / (2 * radius)

    uvAttribute.setXY(i, u, v)
  }
}

/**
 * 描画する
 */
const render = async () => {
  if (renderTimer.value) {
    clearTimeout(renderTimer.value)
  }

  if (renderer.value && camera.value && scene.value) {
    let renderSource: HTMLElement | HTMLVideoElement | HTMLImageElement | null = source.value

    if (!isLowerMinScale.value) {
      if (fisheyeCtx.value && renderSource) {
        if (props.useVideo && useBrowserName() === 'safari') {
          try {
            renderSource = await getArchiveImgForSafari()

            const videoSource = source.value as HTMLVideoElement
            if (videoSource.paused && !props.isPaused) {
              videoSource.play()
            }
          } catch (e) {
            // 映像切替時にエラーになる場合があるが何もしない
          }
        }
        const [sx, sy, sw, sh, dx, dy, dw, dh] = pos.value
        fisheyeCtx.value.drawImage(
          renderSource as HTMLCanvasElement | HTMLVideoElement | HTMLImageElement,
          sx,
          sy,
          sw,
          sh,
          dx,
          dy,
          dw,
          dh
        )

        textures.value.forEach((tex) => {
          tex.needsUpdate = true
        })

        renderer.value.render(scene.value, camera.value)
      }
    } else if (!props.useVideo && normalViewerCtx.value && props.liveImg) {
      normalViewerCtx.value.drawImage(
        props.liveImg as HTMLImageElement,
        0,
        0,
        props.cameraDetail?.image_rs_width as number,
        props.cameraDetail?.image_rs_height as number
      )
    }
  }

  renderTimer.value = setTimeout(() => {
    void render()
  }, updateInterval.value)
}

/**
 * Safari用のvideoを画像に変換して返却
 */
const getArchiveImgForSafari = () => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const url = window.URL || window.webkitURL

    if (archiveImg.src) {
      url.revokeObjectURL(archiveImg.src)
    }

    const videoSource = source.value as HTMLVideoElement
    const tmpCanvas = document.createElement('canvas')
    tmpCanvas.width = videoSource.videoWidth
    tmpCanvas.height = videoSource.videoHeight
    const context = tmpCanvas.getContext('2d') as CanvasRenderingContext2D
    context.drawImage(videoSource, 0, 0, videoSource.videoWidth, videoSource.videoHeight)

    tmpCanvas.toBlob((blob) => {
      archiveImg.onload = () => resolve(archiveImg)
      archiveImg.onerror = (e) => reject(e)
      if (blob) {
        archiveImg.src = url.createObjectURL(blob)
      } else {
        reject(new Error('archive image load error'))
      }
      tmpCanvas.remove()
    })
  })
}

/**
 * UIの操作
 */
const drag = (type: string, offsetX: number, offsetY: number) => {
  if (!camera.value || !local.value || !collisionSphere.value || !THREE) {
    return
  }
  const { width, height } = canvasSize.value
  if (!width || !height) {
    return
  }
  const mouseX = -(offsetX / width) * 2 + 1
  const mouseY = -(offsetY / height) * 2 + 1
  const dragPos = new THREE.Vector3(mouseX, mouseY, 1)

  dragPos.unproject(camera.value)
  const ray = new THREE.Raycaster(
    camera.value.position,
    dragPos.sub(camera.value.position).normalize()
  )
  const objs = ray.intersectObjects([collisionSphere.value])
  if (objs.length === 0) {
    return
  }
  const obj = objs[0]
  if (type === 'start') {
    prevEuler.value = toEuler(obj.point)
    return
  }
  const curr = toEuler(obj.point)
  let pitch = -local.value.rotation.x - (curr.pitch - prevEuler.value.pitch)
  // shallowRef の meshes は computed で追えないため、ここで直接読む
  const currentYaw = meshes.value.length === 0 ? 0 : meshes.value[0].rotation.z
  const nextYaw = currentYaw - (curr.yaw - prevEuler.value.yaw)

  if (pitch < cameraPitchMax.value) {
    pitch = cameraPitchMax.value
  }
  if (pitch > cameraPitchMin.value) {
    pitch = cameraPitchMin.value
  }

  setPitch(pitch)
  setYaw(nextYaw)

  prevEuler.value = curr
}

/**
 * オイラー角に変換
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toEuler = (ptr: any) => {
  const [x, y, z] = [-ptr.z, ptr.x, ptr.y]
  const nextYaw = -Math.atan2(y, x)
  const pitch = Math.atan2(z, Math.sqrt(x * x + y * y))
  return { yaw: nextYaw, pitch }
}

/**
 * マウスホイールの操作
 */
const wheel = (e: WheelEvent & { wheelDelta?: number }) => {
  // THREE 初期化前に trackpad / ホイールが飛ぶことがある
  if (!camera.value || !local.value) {
    return
  }
  const incrementVal = 0.005
  let nextZoom = zoom.value
  if (e.wheelDelta > 0 && nextZoom < calibration.value.maxZoom) {
    nextZoom += incrementVal
  } else if (e.wheelDelta < 0 && nextZoom >= calibration.value.minZoom) {
    nextZoom -= incrementVal
  }
  setZoom(nextZoom)
}

/**
 * マウスホイール操作のコーチマークを表示
 */
const showCoachMark = () => {
  if (!displayedCoachMark.value) {
    isShowCoachMark.value = true
    setTimeout(() => {
      isShowCoachMark.value = false
      setDisplayedCoachMark(true)
    }, 3000)
  }
}

onBeforeUnmount(() => {
  clearTimeout(renderTimer.value as ReturnType<typeof setTimeout>)
  resetState()
})

onMounted(async () => {
  if ((window.navigator as Navigator & { msSaveBlob?: unknown }).msSaveBlob) {
    return
  }

  THREE = await import('three')
  const renderElm = props.useVideo ? video.value : props.liveImg

  initFisheyeViewer()
  setSrc(renderElm)
  if (props.displaySize) {
    setCanvasSize(props.displaySize)
  }
  setCameraPose({ pitch: 1.5, yaw: 0 })
  setZoom(calibration.value.minZoom)
  setFisheyeRegion({
    centerX: cameraSize.value.width / 2,
    centerY: cameraSize.value.height / 2,
    radius: calibration.value.radius,
  })

  setEvent()

  if (!props.useVideo) {
    initNormalLiveViewer()
  }

  if (fisheyeViewer.value && canvas.value) {
    fisheyeViewer.value.appendChild(canvas.value)
  }
  await render()

  showCoachMark()
  emit('setFisheyeViewerElement', fisheyeViewerWrap.value)
  emit('setVideoElement', video.value)
})

watch(
  () => props.liveImageSrc,
  (v) => {
    if (v) {
      void render()
    }
  }
)

watch(isLowerMinScale, (v) => {
  const displayState = v ? 'normal' : 'fisheye'
  setDisplayState(displayState)
})

watch(
  () => props.displaySize,
  () => {
    resize()
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ResizeBox), { onResize: resize }, {
      default: _withCtx(() => [
        (__props.useVideo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle(_unref(videoStyle)),
              class: _normalizeClass({ normal: _unref(isLowerMinScale), fisheye: !_unref(isLowerMinScale) }),
              onWheel: _withModifiers(wheel, ["prevent"]),
              ref_key: "fisheyeViewerWrap",
              ref: fisheyeViewerWrap
            }, [
              _createElementVNode("div", {
                ref_key: "fisheyeViewer",
                ref: fisheyeViewer,
                class: "fisheye_viewer"
              }, null, 512),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("video", {
                  ref_key: "video",
                  ref: video,
                  id: "video",
                  src: __props.videoPath,
                  muted: "",
                  playsinline: "",
                  autoplay: "",
                  crossorigin: "anonymous",
                  onLoadeddata: _cache[0] || (_cache[0] = ($event: any) => (emit('loadeddata', video.value))),
                  onEnded: _cache[1] || (_cache[1] = ($event: any) => (emit('ended'))),
                  onError: _cache[2] || (_cache[2] = ($event: any) => (emit('error')))
                }, null, 40, _hoisted_3)
              ])
            ], 46, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["live-viewer", { normal: _unref(isLowerMinScale), fisheye: !_unref(isLowerMinScale) }]),
              style: _normalizeStyle(_unref(videoStyle)),
              onWheel: _withModifiers(wheel, ["prevent"]),
              ref_key: "fisheyeViewerWrap",
              ref: fisheyeViewerWrap
            }, [
              _createElementVNode("div", {
                ref_key: "fisheyeViewer",
                ref: fisheyeViewer,
                class: "fisheye_viewer"
              }, null, 512),
              _createElementVNode("canvas", {
                ref_key: "normalViewer",
                ref: normalViewer,
                width: __props.cameraDetail.image_rs_width,
                height: __props.cameraDetail.image_rs_height,
                style: _normalizeStyle(_unref(canvasStyle))
              }, null, 12, _hoisted_5)
            ], 46, _hoisted_4))
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (isShowCoachMark.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('fisheye_viewer.coach_mark_message')
                }, null, 8, _hoisted_9)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})